<template>
<div class="ui-content dashboard">
    <div v-if="step==1" class="full-size-block" >
        <v-card class="mx-auto normal-card autohg create-test-cust cust-test-create">
            <div  class="add-user-form-test cust-test-blk MYTPatternI">
                <MYTPatternI :data="stepOneData" :onNextClick="onNextClick" />
            </div>
        </v-card>
    </div>
    <div v-if="step==2" class="full-size-block step-2">
        <v-card class="mx-auto normal-card autohg create-test-cust cust-test-create">
            <div v-if="step==2" class="add-user-form-test cust-test-blk MYTPatternII MYTPatternTest ">
                <MYTPatternII
                    :data="stepTwoData"
                    :stepOneData="stepOneData"
                    :onBackClick="onBackClick"
					:onCustomizeClick="onCustomizeClick"
                />
            </div>
        </v-card>
    </div>
</div> 
</template>

<script>
import MYTPatternI from "@/components/coordinator/Tests/CustomizedTests/MYTPatternI.vue";
import MYTPatternII from "@/components/coordinator/Tests/CustomizedTests/MYTPatternII.vue";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
    name: "CustomizedTests",
    components: {
        MYTPatternI,
        MYTPatternII,
    },
    computed: {
        ...mapState("userStore", ["user"]),
    },
    mounted() {
        this.getUserDetails();
        this.addBreadCrumbChilde([
            {
                text: "Create New test",
                disabled: false,
            },
            {
                text: "1.Name, Pattern & Subjects",
                disabled: false,
            },
        ]);
    },
    beforeDestroy() {
        this.addBreadCrumbChilde([]);
    },
    data() {
        return {
            step: 1,
            stepOneData: null,
            stepTwoData: null,
			stepThreeData: null
        };
    },

    methods: {
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        ...mapActions({
            getTestList: "testStore/getTestList",
            me: "userStore/me",
        }),
        getUserDetails() {
            // this.me()
            //     .then((response) => {
                    // if (this.user.institute_type == this.types.SILVER) {
                    //     this.$router.push("customized-tests");
                    // }
                // })
                // .catch((err) => {});
        },
        onNextClick(data, isCustomizeSyllabus = false) {
                if (isCustomizeSyllabus || this.validate(data)) {

                this.stepOneData = data;
                this.step = this.step + 1;

                this.addBreadCrumbChilde([
                    {
                        text: "Create New test",
                        disabled: false,
                    },
                    {
                        text: "2.Customized Syllabus",
                        disabled: false,
                    },
                ]);
            }
        },
        onBackClick(data) {
            this.addBreadCrumbChilde([
                {
                    text: "Create New test",
                    disabled: false,
                },
                {
                    text: "1.Name, Pattern & Subjects",
                    disabled: false,
                },
            ]);
            this.stepTwoData = data;
            this.step = this.step - 1;
        },
          validate(data) {
            let subject_ids = [];
            if (!data || !data.testName || data.testName.trim().length === 0) {
                this.$toasted.error(`Please enter test name`, { icon: "info" });
                return false;
            } else if (
                !data.selectedTarget ||
                data.selectedTarget.length === 0
            ) {
                this.$toasted.error(`Please select exam target`, {
                    icon: "info",
                });
                return false;
            } else if (!data.selectedClasses) {
                this.$toasted.error(`Please select data type`, {
                    icon: "info",
                });
                return false;
            } else if (
                !data.selectedSubjects ||
                data.selectedSubjects.length === 0
            ) {
                this.$toasted.error(`Please select subject`, { icon: "info" });
                return false;
            } else if (data.selectedSubjects && data.selectedSubjects.length) {
                let subjectIds = [];
                let valid = true;

                data.selectedSubjects.map((s) => {
                    if (!s.difficulty) {
                        this.$toasted.error(
                            `Please select difficulty level for ${s.title}`,
                            { icon: "info" }
                        );
                        valid = false;
                    }
                });
                data.selectedSubjects.map((s) => {
                    if (
                        this.selectedPatterns &&
                        this.selectedPatterns.test_params &&
                        this.selectedPatterns.test_params.length
                    ) {
                        this.selectedPatterns.test_params.map((t) => {
                            if (
                                data.selectedTarget === 2 ||
                                (data.selectedTarget === 1 &&
                                    data.selectedPatterns.id !== 17)
                            ) {
                                if (
                                    t.validate_subject_ids &&
                                    !t.validate_subject_ids.includes(s.id) &&
                                    !subjectIds.includes(s.id)
                                ) {
                                    this.$toasted.error(
                                        `You cannot select ${s.title} subject for this pattern`,
                                        { icon: "info" }
                                    );
                                    subjectIds.push(s.id);
                                    valid = false;
                                }
                            } else if (
                                t.subject_ids[0] &&
                                !t.subject_ids[0].length &&
                                !t.subject_ids.includes(s.id) &&
                                !subjectIds.includes(s.id)
                            ) {
                                this.$toasted.error(
                                    `You cannot select ${s.title} subject for this pattern`,
                                    { icon: "info" }
                                );
                                subjectIds.push(s.id);
                                valid = false;
                            } else {
                                if (
                                    data.selectedSubjects.length > 1 &&
                                    data.selectedPatterns.id === 17
                                ) {
                                    let subjects = data.selectedSubjects.map(
                                        (sd) => sd.id
                                    );

                                    let subjects_to_be_checked = t.subject_ids.filter(
                                        (st) => st.length === 3
                                    );
                                    if (
                                        subjects &&
                                        subjects.length === 3 &&
                                        !subjects_to_be_checked.includes(
                                            subjects
                                        )
                                    ) {
                                        subjects_to_be_checked.map((st) => {
                                            // if (s.length === 3) {
                                            let invalidSubjects = subjects.filter(
                                                (sd) => !st.includes(sd)
                                            );
                                            invalidSubjects.map((is) => {
                                                if (!subjectIds.includes(is)) {
                                                    const dub = data.selectedSubjects.find(
                                                        (ts) => ts.id === is
                                                    );
                                                    this.$toasted.error(
                                                        `You cannot select ${dub.title} subject for this pattern`,
                                                        { icon: "info" }
                                                    );
                                                    subjectIds.push(dub.id);
                                                }
                                            });
                                            valid = false;
                                            // }
                                        });
                                    } else if (
                                        subjects.length === 2 ||
                                        subjects.length === 4
                                    ) {
                                        this.$toasted.error(
                                            `You cannot select ${subjects.length} subject for this pattern`,
                                            { icon: "info" }
                                        );
                                        valid = false;
                                    }
                                }
                            }
                            subjectIds.push(s.id);
                        });
                    }
                });
                if (!valid) {
                    return false;
                }
            } 
            return true;
        },
		onCustomizeClick(data) {
            this.step = this.step + 1;
            this.addBreadCrumbChilde([
                {
                    text: "Create New test",
                    disabled: false,
                },
                {
                    text: this.stepOneData.testName,
                    disabled: false,
                },
				{
                    text: "Customized Syllabus",
                    disabled: false,
                },
            ]);
            this.stepTwoData = data;
        },
    },
};
</script>